import React from "react";

export function VehicleSegmentFormatter(cellContent) {
    const segmentConfig = {
        'SMALL': {
            displayText: 'Small',
            color: 'info',
            icon: '🚗'
        },
        'MEDIUM': {
            displayText: 'Medium',
            color: 'primary',
            icon: '🚙'
        },
        'LARGE': {
            displayText: 'Large',
            color: 'warning',
            icon: '🚐'
        },
        'PREMIUM': {
            displayText: 'Premium',
            color: 'dark',
            icon: '✨'
        }
    };

    const config = segmentConfig[cellContent] || {
        displayText: cellContent,
        color: 'secondary',
        icon: ''
    };

    return (
        <span className={`badge badge-light-${config.color} fw-bold`}>
            {config.icon && <span className="me-1">{config.icon}</span>}
            {config.displayText}
        </span>
    );
}
